import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'sex-selector',
  templateUrl: './sex-selector.component.html',
  styleUrls: ['./sex-selector.component.scss'],
})
export class SexSelectorComponent implements OnInit, OnChanges {
  public hombreColor = 'medium'
  public mujerColor = 'medium'
  public gayColor = 'medium'

  @Input() setSexo: string
  @Output() valueEmit = new EventEmitter<string>()
  constructor() { }

  ngOnInit() {
    this.pintaSeleccion(this.setSexo)
  }

  ngOnChanges(changes: SimpleChanges) {
    this.pintaSeleccion(this.setSexo)
  }

  sexoClick(event: string) {
    const target = event
    this.pintaSeleccion(event)
    this.valueEmit.emit(event)
  }

  pintaSeleccion(id: string) {
    try {
      switch (id) {
        case 'hombre':
          this.hombreColor = 'primary'
          this.mujerColor = 'medium'
          this.gayColor = 'medium'
          break
        case 'mujer':
          this.hombreColor = 'medium'
          this.mujerColor = 'primary'
          this.gayColor = 'medium'
          break
        case 'no especificar':
          this.hombreColor = 'medium'
          this.mujerColor = 'medium'
          this.gayColor = 'primary'
          break
        default:
          this.hombreColor = 'medium'
          this.mujerColor = 'medium'
          this.gayColor = 'primary'
          break
      }
      // console.log(this.hombreColor, this.mujerColor, this.gayColor)
    } catch (error) {
      console.log(error)
    }
  }
}
